export default function prepareValue (value) {
  if (value instanceof Date) {
    return value.toISOString()
  } else {
    return value
  }
}



// WEBPACK FOOTER //
// ./src/frontend/util/prepareValue.js